import { defineStore } from 'pinia';
import * as mobileApp from '../globals/utilities/MobileApp';
import serverFetch from '../globals/ServerFetch';
import RfpsList from '../app-customer/rfp/RfpsList';

type AdditionalBoxItemName = 'notifications'|'description'|'promotion'|'reviews'|'gallery'|'nip'|'servicesProducts'|'mobileApp';
type AdditionalBoxesMap = { [boxType in AdditionalBoxItemName]: { enabled:boolean } };

// eslint-disable-next-line import/prefer-default-export
export const useCustomerRfpListStore = defineStore({
	id: 'customerRfpList',
	state: () => ({
		rfpsList: new RfpsList('Rfps'),
		contactsList: new RfpsList('Contacts'),
		additionalBoxes: {} as AdditionalBoxesMap,
		displayApContactsIncentiveBox: false,
		displayApRfpListIncentiveBox: false,
	}),
	actions: {
		async shouldDisplayApContactsIncentiveBox() {
			const response = await serverFetch('/customer/should-display-ap-contacts-stimulation-box.do', {}, 'GET', false, false);
			this.displayApContactsIncentiveBox = response.shouldDisplayApStimulationBox;
		},
		async shouldDisplayApRfpListIncentiveBox() {
			const response = await serverFetch('/customer/should-display-ap-rfp-list-stimulation-box.do', {}, 'GET', false, false);
			this.displayApRfpListIncentiveBox = response.shouldDisplayApStimulationBox;
		},
		async updateAdditionalBoxes(rsvp?) {
			if (!rsvp) {
				rsvp = await serverFetch('/profile/hello.ofer');
			}

			if (!rsvp.user || !rsvp.user.boxes) { return; }

			if (!mobileApp.canShowDownloadAppPrompt()) {
				rsvp.user.boxes['mobileApp'] = false;
			}

			let push = typeof Notification === 'function' && Notification.permission === 'default';
			if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) { push = false; }

			const result = {
				notifications: {
					enabled: push,
				},
			} as AdditionalBoxesMap;

			Object.keys(rsvp.user.boxes).forEach((value) => {
				const boxName = value as AdditionalBoxItemName;
				result[boxName] = { enabled: rsvp.user.boxes[boxName] };
			});

			this.additionalBoxes = result;
		},
		getList(listType: 'Rfps'|'Contacts') {
			const listName = listType ? listType.toLowerCase() : 'rfps';
			return this[`${listName}List` as 'rfpsList'|'contactsList'];
		},
		updateFlags(flags: string[]) {
			if (flags && flags.indexOf('show_best_rfps') > -1) {
				this.getList('Rfps').ShowBestRfps = true;
			}
		},
	},
});
